import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';

import AccessibleTextArea from '@bibliocommons/deprecated-base-accessibility-text-area';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { bibShape } from '@bibliocommons/bc-prop-types';

import shelfItemShape from 'app/shapes/shelves/shelfItemShape';
import BaseUGCEditor from '../BaseUGCEditor';

import './TextUGCEditor.scss';

export default class TextUGCEditor extends React.PureComponent {
  renderTextArea() {
    const {
      bib,
      characterLimit,
      errorKey,
      placeholder,
      handleTextChange,
      text,
      textAreaLabel,
      textAreaRef
    } = this.props;
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);

    return (
      <div>
        <ScreenReaderMessage>
          <label htmlFor={`editor-textarea-${metadataId}`} id={`label-${metadataId}`}>
            {textAreaLabel}
          </label>
        </ScreenReaderMessage>
        <AccessibleTextArea
          required
          fitToText
          name="text"
          className="editor-textarea"
          errorKey={errorKey}
          maxLength={characterLimit}
          placeholder={placeholder}
          id={`editor-textarea-${metadataId}`}
          handleChange={handleTextChange}
          ref={textAreaRef}
          value={text}
        />
      </div>
    );
  }

  render() {
    const {
      bib,
      className,
      text,
      renderHeader,
      handleSave,
      handleClose,
      handleReset,
      isSaving,
      showPrivacyAlert,
      renderCustomPrivacyAlert,
      shelfItem,
      shelfTransactions,
      shelfActions
    } = this.props;

    return (
      <BaseUGCEditor
        bib={bib}
        className={cn('cp-text-ugc-editor', className)}
        renderHeader={renderHeader}
        handleSave={handleSave}
        handleClose={handleClose}
        handleReset={handleReset}
        isSaving={isSaving}
        saveButtonDisabled={text.length <= 0}
        showPrivacyAlert={showPrivacyAlert}
        renderCustomPrivacyAlert={renderCustomPrivacyAlert}
        shelfItem={shelfItem}
        shelfTransactions={shelfTransactions}
        shelfActions={shelfActions}
      >
        {this.renderTextArea()}
      </BaseUGCEditor>
    );
  }
}

TextUGCEditor.propTypes = {
  bib: bibShape.isRequired,
  characterLimit: PropTypes.number,
  className: PropTypes.string,
  errorKey: PropTypes.string,
  text: PropTypes.string,
  textAreaRef: PropTypes.func,
  handleClose: PropTypes.func,
  handleReset: PropTypes.func,
  handleSave: PropTypes.func.isRequired,
  handleTextChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  isSaving: PropTypes.bool.isRequired,
  showPrivacyAlert: PropTypes.bool.isRequired,
  renderCustomPrivacyAlert: PropTypes.func,
  renderHeader: PropTypes.func.isRequired,
  shelfItem: shelfItemShape,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  textAreaLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

TextUGCEditor.defaultProps = {
  characterLimit: 1000,
  errorKey: 'text',
  text: ''
};
